if (!customElements.get('product-modal')) {
  customElements.define('product-modal', class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      this.hydrateMedia();
      super.show(opener);
      this.showActiveMedia();
    }

    // The images are rendered with data-src/data-srcset (see
    // snippets/product-media.liquid) so nothing downloads while the modal is
    // hidden. Move the URLs into place the first time it opens.
    hydrateMedia() {
      this.querySelectorAll('img[data-src]').forEach((img) => {
        if (img.dataset.srcset) img.setAttribute('srcset', img.dataset.srcset);
        img.setAttribute('src', img.dataset.src);
        img.removeAttribute('data-src');
        img.removeAttribute('data-srcset');
      });
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
        element.classList.remove('active');
      }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      if (activeMedia.nodeName == 'DEFERRED-MEDIA') {
        activeMedia.loadContent();
      }
    }
  });
}
